import { FileAttachmentClass } from '../common/file-attachment/file-attachment-class';
export class Tsk5030Class {
    ApprovalId:number;
    TaskId:number;
    TaskDetailsId:number;
    ApprovedCurrentdate : Date
    ApprovedComments : String
    TableName:string;
AutoId:number;
    AttachmentList:  Array<FileAttachmentClass> = [];
    ApproveBulkList: Array<Tsk5030Class>=[];
}
